/* eslint-disable */
import React, { Component } from "react";
import _ from "lodash";
import styled from "styled-components";
import { withRouter } from "react-router";
import styles from "./styles.scss";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  ReservationSummary,
  CheckoutForm,
  TpvForm,
  MercadoPago,
  PayNoPainBridge,
  StripeBridge,
  WitbookingPaymentBridge,
  Footer,
  PaypalBridge,
} from "~/components";
import {
  customerFormFieldsSelector,
  paymentFormFieldsSelector,
  ccFormFieldsSelector,
  paymentTypeSelector,
  serviceHasImageSelector,
  reservationResourceSelector,
  loadingSelector,
  showCheckoutFormSelector,
  servicesCollapsedSelector,
  pciProxyResponseSelector,
  pciProxyErrorSelector,
  communicationsDisclaimerSelector,
  privacyPolicySelector,
  earliestCancellationDateSelector,
  reservationsDatesSelector,
  sortedServicesSelector,
  showExtrasModalSelector,
  hideDefaultPrivacyPolicySelector,
  pnpV2PaymentOrderSuccessSelector,
  pnpV2PaymentOrderErrorSelector,
  formAsyncValidationErrorsSelector,
  pnpV2PaymentTokenSelector,
  showServicesSelector,
  isSharedBookingSelector,
} from "./selectors";
import { actions } from "./reducer";
import { actions as appActions } from "../App";
import { actions as reservationActions } from "../ReservationManager";
import constants from "../../utils/constants";
import { executeEvent, redirectUrl } from "../../utils/misc";
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import { Sticky } from "react-sticky";
import classnames from "classnames";
import { getFromSessionStorage, saveToSessionStorage } from "../../utils/misc";
import { selectors as appSelectors } from "../App";
import { selectors as reservationSelectors } from "../ReservationManager";
import get from "lodash/get";
import { createStripeFirstCharge } from "../../utils/witbookingApi";
import { StyckyCheckout, ReservationTotalAmount } from "@witbooking/react-components";
import {
  extrasQuestionnaireSelector,
  guestFormQuestionnaireSelector,
  availablePaymentsSelector,
  selectedPaymentSelector,
  reservationTotalAmountSelector,
} from "../ReservationManager/selectors";
import { hideObligatoryExtrasSelector, showBestPriceGuaranteedSelector } from "../App/selectors";
import { withSessionData } from "../../utils/session";
import { genericHandleSubmit, handleMap, validate } from "./utils";
import { ExitStep } from "../../utils/EngineDataColllector/EngineData";
import { updateExitStep } from "../../utils/EngineDataColllector/EngineDataCollector";
import ARILoader from "../RoomSelection/components/ARILoader/ARILoader";
import ModalMessage from "../RoomSelection/components/ModalMessage/ModalMessage";
import axios from "axios";
import { pushCheckoutEvent, pushRemoveFromCartEvent } from "../../helpers/EnhancedEcommerce";
import { CartAbandonmentContext } from "../../contexts/cart-abandonment/application/CartAbandonmentContext";
import { Map } from "immutable";
const selectors = { ...appSelectors, ...reservationSelectors };
/*
 * TODO: WHEN THIS LOADS, ASK THE API FOR THE CURRENT PRICE OF THE SELECTED RESERVATIONS IN THE INVENTORY
 * */
const msgs = defineMessages({
  total: {
    id: "checkout.total",
    description: "total",
    defaultMessage: "Total",
  },
  addAnother: {
    id: "checkout.addAnother",
    description: "addAnother",
    defaultMessage: "Add another reservation",
  },
  shareBookingCart: {
    id: "app.share_booking.share_booking_cart",
    description: "Share booking cart",
    defaultMessage: "Share booking cart",
  },
  checkout: {
    id: "checkout.checkout",
    description: "checkout",
    defaultMessage: "Checkout",
  },
  or: {
    id: "checkout.controlsSeparator",
    description: "Or",
    defaultMessage: "or",
  },
  share: {
    id: "checkout.share",
    description: "Share booking cart",
    defaultMessage: "Share booking cart",
  },
  totalTaxes: {
    id: "checkout.additional_info.totalTaxes",
    description: "Total taxes included",
    defaultMessage: "Total taxes included",
  },
  payNow: {
    id: "checkout.additional_info.payNow",
    description: "Pay now",
    defaultMessage: "Pay now",
  },
  noDeposit: {
    id: "checkout.additional_info.noDeposit",
    description: "No deposit required",
    defaultMessage: "No deposit required",
  },
  viewMap: {
    id: "checkout.additional_info.viewMap",
    description: "View map",
    defaultMessage: "view map",
  },
  informativeMsg: {
    id: "checkout.additional_info.informativeMsg",
    description: "Informs about payment occurs in default currency of hotel",
    defaultMessage: "Merely informative. Payments in",
  },
  removeCart: {
    id: "checkout.removeCart",
    description: "Asks to user if they want to remove cart",
    defaultMessage: "Delete previous booking?",
  },
  keepMsg: {
    id: "checkout.keepMsg",
    description: "Keep",
    defaultMessage: "keep",
  },
  deleteMsg: {
    id: "checkout.deleteMsg",
    description: "Delete",
    defaultMessage: "delete",
  },
  emptyCart: {
    id: "checkout.emptyCart",
    description: "Empty cart",
    defaultMessage: "Empty cart",
  },
  bookingTotal: {
    id: "checkout.bookingTotal",
    description: "Total booking",
    defaultMessage: "Total booking",
  },
  bookingsTotal: {
    id: "checkout.bookingsTotal",
    description: "Total booking in plural",
    defaultMessage: "Total bookings",
  },
  taxesIncluded: {
    id: "checkout.booking_total.taxesIncluded",
    description: "Taxes included",
    defaultMessage: "Taxes included",
  },
  payAtProperty: {
    id: "checkout.payAtProperty",
    description: "Pay at the property",
    defaultMessage: "Pay at the property",
  },
  deposit: {
    id: "checkout.deposit",
    description: "Deposit",
    defaultMessage: "Deposit",
  },
  informativeMsgShort: {
    id: "checkout.informativeMsg",
    description: "Merely informative",
    defaultMessage: "Merely informative",
  },
  myBooking: {
    id: "checkout.myBooking",
    description: "My booking",
    defaultMessage: "My booking",
  },
  propertyIsDemo: {
    id: "checkout.propertyIsDemo",
    description: "Message that alerts that bookings are not valid because property is demo",
    defaultMessage: "ATTENTION! This is demo mode and the bookings are not valid",
  },
  failedPayment: {
    id: "checkout.failedPayment",
    description: "Message shown after a failed payment",
    defaultMessage: "Failed Payment!",
  },
});

const StyledARILoaderContainer = styled.div`
  :before {
    content: " ";
    z-index: 3000;
    display: block;
    position: fixed;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.75);
  }
`;

const getEnhancedEcommerceReservation = reservation => {
  return {
    ticker: reservation.get("inventory").get("accommodation").get("ticker"),
    title: reservation.get("inventory").get("accommodation").get("name"),
    configurationName: reservation.get("inventory").get("configuration").get("name"),
    mealPlanName: reservation.get("inventory").get("mealplan").get("name"),
    conditionName: reservation.get("inventory").get("condition").get("name"),
    quantity: reservation.get("numberOfUnits"),
    totalRate: reservation.get("originalTotalRate"),
  };
};

const ConfirmRemoveCart = ({
  numberOfReservations,
  handleRemove,
  handleRemoveCart,
  handleClose,
}) => {
  return (
    <div className={classnames("wbkv9-Checkout-ConfirmRemoveCart", styles.confirmRemoveCart)}>
      <div className={classnames("wbkv9-Checkout-RemoveCartText", styles.removeCartText)}>
        <FormattedMessage {...msgs.removeCart} />
      </div>

      <div
        className={classnames(
          "wbkv9-Checkout-ConfirmRemoveCart-buttonsContainer",
          styles.buttonsContainer
        )}>
        <button
          className={classnames(
            "wbkv9-Checkout-ConfirmRemoveCart-confirmButton",
            styles.confirmButton
          )}
          onClick={handleClose}>
          <FormattedMessage {...msgs.keepMsg} />
        </button>

        <button
          className={classnames(
            "wbkv9-Checkout-ConfirmRemoveCart-cancelButton",
            styles.cancelButton
          )}
          onClick={handleRemove}>
          <FormattedMessage {...msgs.deleteMsg} />
        </button>

        {numberOfReservations > 1 && (
          <button
            className={classnames("wbkv9-Checkout-ConfirmRemoveCart-empty", styles.empty)}
            onClick={handleRemoveCart}>
            <FormattedMessage {...msgs.emptyCart} />
          </button>
        )}
      </div>
    </div>
  );
};

class Checkout extends Component {
  static contextType = CartAbandonmentContext;

  constructor(props) {
    super(props);
    const hideExtrasModal = props.location.state && props.location.state.hideExtrasModal;
    this.state = {
      isModalOpen: !!(
        props.messages && props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_2)
      ),
      isCheckoutVisible:
        this.props.showCheckoutForm !== constants.SHOW_CHECKOUT_FORM.ON_CLICK_BUTTON,
      customFormValues: {},
      formsValid: {},
      touch: false,
      values: {
        name: get(props.session, "guestData.name", ""),
        lastName: get(props.session, "guestData.surname", ""),
        phone: get(props.session, "guestData.phone", ""),
        phonePrefix: get(props.session, "guestData.phoneCountryCode"),
        email: get(props.session, "guestData.email", ""),
        country: get(props.session, "guestData.countryCode", ""),
        repeatEmail: get(props.session, "guestData.email", ""),
        address: get(props.session, "guestData.address"),
        idDocument: get(props.session, "guestData.idDocument"),
        arrivalTime: get(props.session, "guestData.arrivalTime"),
        comments: get(props.session, "guestData.comments"),
        newsletter: get(props.session, "guestData.receiveOffers"),
        ccHolderName: "",
        ccNumber: "",
        ccType: "",
        expirationMonth: "",
        expirationYear: "",
        hasAcceptedConditions: false,
      },
      errors: {},
      touched: {},
      paymentError: false,
      loader: true,
      hideExtrasModal: !!hideExtrasModal,
      criptanLoading: false,
    };
    this.stripeBridge = null;
    this.witbookingPaymentBridge = null;
    this.paypalBridge = null;
    this.checkoutEventPushed = false;
    this.handleRemoveReservation = this.handleRemoveReservation.bind(this);
    this.handleAddReservation = this.handleAddReservation.bind(this);
    this.handleShareBookingCart = this.handleShareBookingCart.bind(this);
    this.avoidExpand = this.avoidExpand.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleShowCheckout = this.handleShowCheckout.bind(this);
    this.handleAddReservation = this.handleAddReservation.bind(this);
    this.handleSelectPaymentType = this.handleSelectPaymentType.bind(this);
    this.handleTokenizedPaymentSuccess = this.handleTokenizedPaymentSuccess.bind(this);
    this.handleTokenizedPaymentFailure = this.handleTokenizedPaymentFailure.bind(this);
    this.stripeResponseHandler = this.stripeResponseHandler.bind(this);
    this.stripeClosedHandler = this.stripeClosedHandler.bind(this);
    this.paypalClosedHandler = this.paypalClosedHandler.bind(this);
    this.paypalResponseHandler = this.paypalResponseHandler.bind(this);
    this.handleChangeNumberOfUnits = this.handleChangeNumberOfUnits.bind(this);
    this.handleRemoveLastReservation = this.handleRemoveLastReservation.bind(this);
    this.handleRemoveCart = this.handleRemoveCart.bind(this);
    this.handleChangeLocale = this.handleChangeLocale.bind(this);
    this.handleChangeConfiguration = this.handleChangeConfiguration.bind(this);
    this.handlePCIProxySubmit = this.handlePCIProxySubmit.bind(this);
  }

  avoidExpand(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  handleModal(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.setState({ isModalOpen: false });
    return false;
  }

  handleShareBookingCart() {
    this.props.handleShareBookingCart();
  }

  handleRemoveReservation(reservation) {
    this.props.removeReservation({
      id: reservation.get("id"),
      propertyTicker: reservation.get("propertyTicker"),
    });
    pushRemoveFromCartEvent(reservation.get("propertyTicker"), [
      getEnhancedEcommerceReservation(reservation),
    ]);
  }

  handleAddReservation() {
    this.props.history.push(`/${this.props.propertyTicker}/availability`);
  }

  handleShowCheckout() {
    this.setState({ isCheckoutVisible: true });
  }

  handleSelectPaymentType(paymentType) {
    this.props.changePaymentType({
      paymentType,
      propertyTicker: this.props.propertyTicker,
    });
  }

  stringToCamelCase = value =>
    value
      .split(" ")
      .map(el => el.charAt(0).toUpperCase() + el.slice(1).toLowerCase())
      .join(" ");

  handleSubmit(e) {
    const {
      customerFormConfiguration,
      paymentFormConfiguration,
      selectedPayment,
      propertyTicker,
      createReservation,
      defaultCurrency,
      cart,
      propertyName,
      locale,
      configuration,
      trackingData,
      propertyContact,
      pnpV2FormValidationErrors,
      createPCIProxy,
      paymentType,
      tags,
    } = this.props;

    const { values, customFormValues, formsValid } = this.state;

    values.name = values.name ? this.stringToCamelCase(values.name) : "";
    values.lastName = values.lastName ? this.stringToCamelCase(values.lastName) : "";

    const { stripeBridge } = this;

    if (e) {
      e.preventDefault();
    }

    const stateUpdateFunction = (errors, touch, touched) => {
      let stState = this.setState;
      stState = stState.bind(this);

      if (errors && touch && touched) {
        return stState({ errors, touch, touched });
      } else if (errors) {
        return stState({ errors });
      }
    };

    try {
      if (window.grecaptcha && window.__additionalData) {
        window.grecaptcha.ready(function () {
          window.grecaptcha
            .execute(window.__additionalData.RECAPTCHA_SITE_KEY, { action: "submit" })
            .then(function (token) {
              genericHandleSubmit(e, {
                formValues: values,
                formsValid,
                customFormValues,
                customerFormConfiguration,
                paymentFormConfiguration,
                selectedPayment,
                propertyTicker,
                createReservation,
                defaultCurrency,
                cart,
                propertyName,
                locale,
                configuration,
                trackingData,
                propertyContact,
                pnpV2FormValidationErrors,
                stripeBridge,
                stateUpdateFunction,
                createPCIProxy,
                paymentType,
                recaptchaToken: token,
                tags,
              });
            });
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  handlePCIProxySubmit({ reservationId, transactionId }) {
    this.props.submitPCIProxyTransaction({
      reservationId,
      transactionId,
      propertyTicker: this.props.propertyTicker,
      ccHolderName: this.state.values.ccHolderName,
      ccType: this.state.values.ccType,
      expirationMonth: this.state.values.expirationMonth,
      expirationYear: this.state.values.expirationYear,
    });
  }

  handlePCIProxyFailure() {
    //FIXME: Implement
  }

  handleTokenizedPaymentSuccess(reservationId) {
    window.wbkPaymentModalPhase = constants.PAYMENT_MODAL_PHASES.CONTINUE;

    executeEvent(constants.EVENTS.PAYMENT_MODAL);

    this.props.handleCloseModal(true);
    this.props.history.push(
      `/${this.props.propertyTicker}/${constants.STEP_PATHS.STEP_3}/${reservationId}/success`
    );
  }

  handleTokenizedPaymentFailure() {
    //TODO: GET TRANSACTION FROM API TO KNOW THE CAUSE OF FAILURE
    this.props.handleCloseModal();
  }

  handleChangeNumberOfUnits({ event, reservation }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const numberOfUnits = parseInt(event.target.value);
    if (!numberOfUnits) {
      this.handleRemoveReservation(reservation);
      return;
    }
    this.props.changeReservationRoomStayNumberOfUnits({
      reservationId: reservation.get("id"),
      propertyTicker: reservation.get("propertyTicker"),
      numberOfUnits,
    });
  }

  handleRemoveLastReservation() {
    const reservation = this.props.cart.reservations.get(-1);
    this.props.removeReservation({
      id: reservation.get("id"),
      propertyTicker: this.props.propertyTicker,
    });
    pushRemoveFromCartEvent(this.props.propertyTicker, [
      getEnhancedEcommerceReservation(reservation),
    ]);
    this.props.handleCloseModal();
  }

  handleRemoveCart() {
    this.props.clearCartData();
    pushRemoveFromCartEvent(
      this.props.propertyTicker,
      this.props.cart.reservations.map(reservation => getEnhancedEcommerceReservation(reservation))
    );
    this.props.handleCloseModal();
  }

  static handleCloseModal() {
    window.wbkPaymentModalPhase = constants.PAYMENT_MODAL_PHASES.CLOSE;

    executeEvent(constants.EVENTS.PAYMENT_MODAL);
  }

  componentDidMount() {
    /* TODO: get only when there's the countries field on the customer form */
    this.props.getCountries(this.props.locale);
    if (this.props.messages && this.props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_2)) {
      this.props.handleModalContent(
        <ModalMessage
          messages={this.props.messages.get(constants.MESSAGE_POSITIONS.MODAL_STEP_2)}
          onCloseModal={() => {
            this.props.handleCloseModal();
          }}
        />,
        {
          hideCloseButton: true,
          onClose: this.props.handleCloseModal(),
        }
      );
    }

    window.wbkPropertyName = this.props.propertyName;

    executeEvent(constants.EVENTS.START_STEP_THREE);

    // Triggers when user clicks browser back button from Checkout and returns to RoomSelection.
    // Open modal that asks user if they want to delete cart.
    window.onpopstate = () => {
      if (
        document.location.pathname.indexOf(constants.STEP_PATHS.STEP_1) !== -1 &&
        this.props.cart &&
        this.props.cart.reservations &&
        this.props.cart.reservations.size > 0
      ) {
        this.props.handleModalContent(
          <ConfirmRemoveCart
            numberOfReservations={this.props.cart.reservations.size}
            handleRemove={this.handleRemoveLastReservation}
            handleRemoveCart={this.handleRemoveCart}
            handleClose={this.props.handleCloseModal}
          />,
          { className: styles.removeCart }
        );
      }
    };

    let demoModalOpenedList = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.DEMO_MODAL_OPENED);
    demoModalOpenedList = (demoModalOpenedList && JSON.parse(demoModalOpenedList)) || {};

    if (
      this.props.propertyIsDemo &&
      this.props.propertyTicker.indexOf("demo_") !== 0 &&
      demoModalOpenedList &&
      !demoModalOpenedList[this.props.propertyTicker]
    ) {
      this.props.handleModalContent(<FormattedMessage {...msgs.propertyIsDemo} />);

      demoModalOpenedList[this.props.propertyTicker] = true;
      saveToSessionStorage(
        constants.LOCAL_STORAGE_KEYS.DEMO_MODAL_OPENED,
        JSON.stringify(demoModalOpenedList)
      );
    }
    this.props.requestARI({
      propertyTicker: this.props.propertyTicker,
      callingTicker: this.props.propertyTicker,
      newConfiguration: {},
      sessionId: this.props.session ? this.props.session.id : null,
    });
  }

  setHeartbeatData() {
    const cartAbandonmentContext = this.context;
    cartAbandonmentContext.setCartAbandonmentLoyaltyData(this.props.loyaltyUser);
    cartAbandonmentContext.setPropertyConfiguration(this.props.configuration);
  }

  async componentDidUpdate(prevProps, prevState) {
    this.setHeartbeatData();

    if (!this.checkoutEventPushed && this.props.cart && this.props.cart.reservations) {
      this.checkoutEventPushed = true;
      pushCheckoutEvent(
        this.props.propertyTicker,
        this.props.cart.reservations.map(reservation =>
          getEnhancedEcommerceReservation(reservation)
        )
      );
    }

    if (
      !this.state.criptanLoading &&
      !prevProps.ariLoading &&
      !this.props.ariLoading &&
      this.state.loader &&
      ((prevProps.availablePayments &&
        this.props.availablePayments &&
        _.isEqual(prevProps.availablePayments.toJS(), this.props.availablePayments.toJS())) ||
        (!prevProps.availablePayments &&
          this.props.availablePayments &&
          this.props.availablePayments.size))
    ) {
      this.setState({ loader: false });
    }
    if (prevState.isCheckoutVisible === false && this.state.isCheckoutVisible === true) {
      this.props.handleScroll("checkoutForm", {
        duration: 750,
        delay: 50,
        offset: -35,
        smooth: true,
      });
    }

    if (prevProps.reservationResource !== this.props.reservationResource) {
      this.setState({ paymentError: false });
    }

    const selectedType =
      this.props.selectedPayment &&
      this.props.selectedPayment.get(this.props.propertyTicker) &&
      this.props.selectedPayment.get(this.props.propertyTicker).get("type");
    if (
      this.props.cart &&
      prevProps.cart &&
      this.props.cart.reservations &&
      this.props.cart.reservations !== prevProps.cart.reservations &&
      this.props.cart.reservations.size === 0
    ) {
      this.props.history.push(`/${this.props.propertyTicker}/availability`);
    }

    if (
      prevProps.reservationTotalAmount &&
      this.props.reservationTotalAmount &&
      prevProps.reservationTotalAmount !== this.props.reservationTotalAmount
    ) {
      this.props.requestARI({
        propertyTicker: this.props.propertyTicker,
        callingTicker: this.props.propertyTicker,
        newConfiguration: {},
        sessionId: this.props.session ? this.props.session.id : null,
      });
    }

    if (
      prevProps.pciProxyResponse !== this.props.pciProxyResponse &&
      this.props.reservationResource
    ) {
      // Successful Response received from PCI Proxy
      const reservationID = this.props.reservationResource.split("/").pop();
      this.props.history.push(
        `/${this.props.propertyTicker}/${constants.STEP_PATHS.STEP_3}/${reservationID}/success`
      );
      return;
    }

    if (
      this.props.pnpV2PaymentOrderSuccess &&
      this.props.pnpV2PaymentOrderSuccess !== prevProps.pnpV2PaymentOrderSuccess
    ) {
      const reservationID = this.props.reservationResource.split("/").pop();
      this.props.history.push(
        `/${this.props.propertyTicker}/${constants.STEP_PATHS.STEP_3}/${reservationID}/success`
      );
      return;
    }

    if (
      this.props.reservationResource &&
      prevProps.reservationResource !== this.props.reservationResource
    ) {
      // Tokenized CC payment
      const reservationID = this.props.reservationResource.split("/").pop();

      if (reservationID) {
        executeEvent(constants.EVENTS.CONTINUE_STEP_THREE);
      }

      if (
        selectedType === constants.PAYMENT_TYPES.PNP_TOKEN ||
        selectedType === constants.PAYMENT_TYPES.SIPAY_TOKENIZED_VAULT
      ) {
        /*TODO: get the resource in a normal way without split */
        const mobileMode = window.innerWidth < 768 || window.innerHeight < 600;

        window.wbkPaymentModalPhase = constants.PAYMENT_MODAL_PHASES.START;

        executeEvent(constants.EVENTS.PAYMENT_MODAL);
        this.props.handleModalContent(
          <PayNoPainBridge
            propertyTicker={this.props.propertyTicker}
            reservationId={reservationID}
            chargeCurrency={this.props.defaultCurrency}
            propertyName={this.props.propertyName}
            propertyContact={this.props.propertyContact}
            locale={this.props.locale}
            handleSuccess={this.handleTokenizedPaymentSuccess}
            handleFailure={this.handleTokenizedPaymentFailure}
          />,
          {
            className: "fullContent withCloseBtn payNoPainForm",
            styles: !mobileMode && {
              maxWidth: 300,
              height: "auto",
              maxHeight: "100%",
              boxShadow: "0px 0px 14px 2px rgba(0,0,0,0.75)",
              "border-radius": "7px",
            },
            mobileMode,
            handleClose: Checkout.handleCloseModal,
          }
        );
      } else if (
        selectedType === constants.PAYMENT_TYPES.POS ||
        selectedType === constants.PAYMENT_TYPES.MERCADOPAGO ||
        selectedType === constants.PAYMENT_TYPES.STRIPE
      ) {
        return;
      } else if (selectedType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT) {
        this.paypalBridge.startPaymentProcess(reservationID);
      } else if (selectedType === constants.PAYMENT_TYPES.PCI_PROXY) {
        console.log("reservation saved");
        console.log("pci proxy payment");
      } else if (
        selectedType === constants.PAYMENT_TYPES.PAY_NO_PAIN_V2 ||
        selectedType === constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY
      ) {
        return;
      } else if (selectedType === constants.PAYMENT_TYPES.CRIPTAN && !this.state.paymentError) {
        const protocol = (window && window.location.protocol) || "http:";
        const domain = (window && window.location.host) || "engine.witbooking.com";
        const url = protocol + "//" + domain;
        try {
          this.setState({ loader: true, criptanLoading: true });
          const response = await axios.post(
            `${url}/api/payments/criptan/properties/${this.props.propertyTicker}/reservations/${reservationID}/deposit`
          );
          if (response?.status === 201) {
            let { locale } = this.props;
            if (!["es", "fr", "pt"].includes(locale)) {
              locale = "en";
            }
            redirectUrl(`${response?.data}?lng=${locale}`);
          }
        } catch (error) {
          console.error(error);
          this.setState({ paymentError: true });
        }
      } else {
        /*TODO: get the resource in a normal way without split */
        const reservationID = this.props.reservationResource.split("/").pop();
        this.props.history.push(
          `/${this.props.propertyTicker}/${constants.STEP_PATHS.STEP_3}/${reservationID}/success`
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.handleExpandPromotions(false);
  }

  paypalResponseHandler() {
    // TODO: CALL API TO NOTIFY SUCCESSFUL PAYMENT AND CHANGE RESERVATION STATE
    const reservationId = this.props.reservationResource.split("/").pop();
    this.props.history.push(
      `/${this.props.propertyTicker}/${constants.STEP_PATHS.STEP_3}/${reservationId}`
    );
    this.props.globalLoading(false);
  }

  paypalClosedHandler() {
    this.props.globalLoading(false);
  }

  stripeResponseHandler({ token, args }) {
    const reservationId = this.props.reservationResource.split("/").pop();
    const { id: stripeToken, email } = token;
    const description = `Booking ID: ${reservationId}`;
    const depositTotal = this.props.cart.depositTotal;
    /* TODO: Review this logic! (isCaptured / amount) */
    createStripeFirstCharge(
      {},
      {
        propertyTicker: this.props.propertyTicker,
        currency: this.props.defaultCurrency,
        locale: this.props.locale,
        amount: depositTotal,
        reservationId,
        stripeToken,
        email,
        description,
        isCaptured: !!(depositTotal && depositTotal > 0),
      }
    )
      .then(() => {
        this.props.history.push(
          `/${this.props.propertyTicker}/${constants.STEP_PATHS.STEP_3}/${reservationId}`
        );
        this.props.globalLoading(false);
      })
      .catch(err => {
        /* TODO: show error */
        console.log("ERROR");
        console.log(err);
        this.props.globalLoading(false);
      });
  }

  stripeClosedHandler() {
    this.props.globalLoading(false);
  }

  handleChangeLocale(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
    this.props.changeLocale({
      propertyTicker: this.props.propertyTicker,
      locale: newConfiguration.locale,
    });
  }

  handleChangeConfiguration(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
  }

  updateCustomFormValues = ({ field, value, label, fieldObject }) => {
    const customFormValues = { ...this.state.customFormValues };
    customFormValues[field] = { value, label, fieldObject };
    this.setState({ customFormValues });
  };

  isFormValid = (formTicker, isValid) => {
    const formsValid = { ...this.state.formsValid };
    formsValid[formTicker] = isValid;
    this.setState({ formsValid });
  };

  touchOnSubmit = () => {
    if (this.state.touch === false) {
      this.setState({ touch: true });
    }
  };

  defineFormField = (name, fieldRef, fieldConfiguration) => {
    const result = {};
    const hasSessionValue = !!get(this.props.session, `guestData.${name}`, "");
    result[name] = {
      value: this.state.values[name],
      name: name,
      error: this.state.errors[name],
      invalid: !!this.state.errors[name],
      touched: this.state.touched[name],
      disabled: false,
      readOnly: false,
      onChange: e => {
        updateExitStep(ExitStep.CUSTOMER_FORM);
        let value = !e.target
          ? e
          : e.target && e.target.type === "checkbox"
          ? e.target.checked
          : e.target.value;

        this.setState(
          s => ({
            values: {
              ...s.values,
              [name]: value,
            },
            touched: {
              ...s.touched,
              [name]: "true",
            },
          }),
          () => {
            //Run validation
            const errors = validate(
              this.state.values,
              {
                fields: Object.values(fieldRef).map(f => f.name),
                fieldConfiguration: fieldConfiguration,
              },
              this.state.formsValid
            );
            this.setState({ errors: errors });
          }
        );
      },
    };
    return result;
  };

  setPaymentError = () => {
    this.setState({ paymentError: true });
  };

  localHandleMap = () => {
    handleMap(this.handleModalContent, this.propertyContact);
  };

  render() {
    /* TODO: GET THIS FROM PROPS / SELECTOR !! */
    const { handleChangeLocale, handleChangeConfiguration } = this;
    const { isModalOpen, isCheckoutVisible } = this.state;
    const {
      cart: {
        reservations,
        pendingTotal,
        bookingTotalRate,
        depositTotal,
        bookingOriginalRate,
        depositOriginalRate,
        pendingOriginal,
        filteredConditions,
        startDateList,
        expiration,
        originalTotalTax,
        originalTotalCityTax,
        bookingOriginalTotalRateWithCityTax,
      } = {},
      serviceHasImage,
      customerFormConfiguration: {
        fields: customerFormFields,
        fieldConfiguration: customerFormFieldConfiguration,
      },
      paymentFormConfiguration: {
        fields: paymentFormFields,
        fieldConfiguration: paymentFormFieldConfiguration,
      },
      paymentType,
      paymentTypesAvailable,
      countries,
      creditCardTypes,
      messages,
      currency,
      loading,
      propertyTicker,
      handleGallery,
      handleModalContent,
      handleCloseModal,
      cancelRelease,
      media,
      defaultCurrency,
      propertyContact,
      propertyName,
      fullWidth,
      showElementsConfig,
      handleConditions,
      locale,
      configuration,
      pendingAmountTextConfiguration,
      iframeMode,
      addObligatoryExtrasRateToRoomSelection,
      showCheckoutForm,
      paymentTypesConfiguration,
      maxBookableRooms,
      showBookingOptionSummary,
      showDiscountsCalculation,
      roomDenomination,
      servicesCollapsed,
      createPCIProxyError,
      communicationsDisclaimer,
      privacyPolicy,
      arePaymentsAvailables,
      customStyles,
      availableLocales,
      availableCurrencies,
      promoCode,
      toggleBookingFormSummary,
      earliestCancellationDate,
      extrasQuestionnaire,
      guestFormQuestionnaire,
      reservationsDates,
      sortedServices,
      showExtrasModal,
      cancellationRestrictions,
      hideDefaultPrivacyPolicy,
      availablePayments,
      selectedPayment,
      cancellationPoliciesInfo,
      hideObligatoryExtras,
      showServices,
      showBestPriceGuaranteed,
      guestsList,
      ariLoading,
      extraFilters,
      propertyActiveTab,
      isTabFiltersCollapsed,
      isSharedBooking,
      affiliateIsEncoded,
      affiliate,
      cityTaxConfiguration,
      taxesText,
    } = this.props;

    const reservationTotalRateToShow =
      taxesText === constants.TAXES_TEXT.TAXES_AND_FEES_INCLUDED
        ? bookingOriginalTotalRateWithCityTax
        : bookingOriginalRate;
    // Get limit date to cancel for each reservation
    // TOOD: Do it on selector!!
    // TODO: DUPLICATED ON APP.js
    const cancelableUntilList = [];
    if (startDateList) {
      for (let startDate in startDateList) {
        cancelableUntilList.push({ startDate, cancelRelease });
      }
    }
    const submitPaypal =
      !this.state.paymentError &&
      this.props.reservationResource &&
      this.props.paymentType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT;
    const submitTpv =
      !this.state.paymentError &&
      this.props.reservationResource &&
      this.props.paymentType === constants.PAYMENT_TYPES.POS;
    const submitMercadopago =
      !this.state.paymentError &&
      this.props.reservationResource &&
      this.props.paymentType === constants.PAYMENT_TYPES.MERCADO_PAGO;
    const idReservation =
      this.props.reservationResource && this.props.reservationResource.split("/").pop();
    const protocol = (window && window.location.protocol) || "http:";
    const domain = (window && window.location.host) || "engine.witbooking.com";
    const url = protocol + "//" + domain;
    const isStripeSupported =
      paymentTypesAvailable &&
      paymentTypesAvailable.size > 0 &&
      paymentTypesAvailable.find(
        element => element.get("type") === constants.PAYMENT_TYPES.STRIPE
      ) !== undefined;
    const isPaypalECSupported =
      paymentTypesAvailable &&
      paymentTypesAvailable.size > 0 &&
      paymentTypesAvailable.find(
        element => element.get("type") === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT
      ) !== undefined;
    let paypalButton = null;
    const selectedType =
      this.props.selectedPayment &&
      this.props.selectedPayment.get(this.props.propertyTicker) &&
      this.props.selectedPayment.get(this.props.propertyTicker).get("type");
    const hideReservation = this.props.session && this.props.session.hideReservation;

    if (isPaypalECSupported) {
      const transaction = {
        name: this.props.propertyName,
        description: (this.props.propertyContact && this.props.propertyContact.get("city")) || "",
        currency: this.props.defaultCurrency,
        locale: this.props.locale,
        amount: this.props.cart.depositTotal,
      };
      paypalButton = (
        <PaypalBridge
          transaction={transaction}
          ref={component => {
            this.paypalBridge = component;
          }}
          configuration={selectedType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT}
          onResponse={this.paypalResponseHandler}
          onClose={this.paypalClosedHandler}
          globalLoading={this.props.globalLoading}
          locale={this.props.locale}
          setErrorCallback={this.setPaymentError}
        />
      );
    }
    const totalRate = (this.props.cart && this.props.cart.bookingTotalRate) || 0;
    let pendingAmount = pendingOriginal;

    if (!pendingAmount) {
      pendingAmount = 0;
    }

    let depositAmount = depositOriginalRate;

    if (!depositAmount) {
      depositAmount = 0;
    }
    let definedFields = {};
    const fields = [...customerFormFields, ...paymentFormFields];
    const fieldConfiguration = customerFormFieldConfiguration.merge(paymentFormFieldConfiguration);
    fields.forEach(field => {
      definedFields[field] = this.defineFormField(field, definedFields, fieldConfiguration)[field];
    });
    const disableUnit = this.props.session && this.props.session.disableUnit;
    return (
      <div className={styles.container}>
        <div className={classnames("wbkv9-Checkout-styckyContainer", styles.styckyContainer)}>
          <Sticky className={styles.ghostSticky}>
            {({ style }) => (
              <div style={style}>
                <StyckyCheckout
                  currency={currency}
                  disableUnit={disableUnit}
                  totalInBasket={
                    <FormattedNumber
                      value={totalRate}
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />
                  }
                  functionAddBooking={this.handleAddReservation}
                />
              </div>
            )}
          </Sticky>
        </div>
        <TpvForm
          propertyTicker={propertyTicker}
          idReservation={idReservation}
          url={url}
          locale={locale}
          submit={submitTpv}
        />
        <MercadoPago submit={submitMercadopago} />
        <WitbookingPaymentBridge
          toggleLoading={this.props.globalLoading}
          ref={component => {
            this.witbookingPaymentBridge = component;
          }}
        />

        {isStripeSupported && (
          <StripeBridge
            ref={component => {
              this.stripeBridge = component;
            }}
            onResponse={this.stripeResponseHandler}
            onClose={this.stripeClosedHandler}
            configuration={selectedType === constants.PAYMENT_TYPES.STRIPE}
          />
        )}
        <div className={styles.checkoutContainer}>
          <div className={styles.checkoutMainContainer}>
            <div
              className={classnames(
                fullWidth && {
                  [styles.sideContainer]: true,
                  [styles.leftContainer]: true,
                  [styles.fullWidth]: true,
                }
              )}>
              {reservations &&
                reservations.map((reservation, idx) => (
                  <ReservationSummary
                    key={idx}
                    currency={currency}
                    fullWidth={fullWidth}
                    onRemoveReservation={this.handleRemoveReservation}
                    checkScroll={this.checkScroll}
                    reservation={reservation}
                    isCheckoutVisible={isCheckoutVisible}
                    addObligatoryExtrasRateToRoomSelection={addObligatoryExtrasRateToRoomSelection}
                    onChangeService={this.props.addServiceToReservation}
                    handleGallery={handleGallery}
                    handleModalContent={handleModalContent}
                    pendingAmountTextConfiguration={pendingAmountTextConfiguration}
                    initiallyExpanded={
                      (!isCheckoutVisible ||
                        showCheckoutForm !== constants.SHOW_CHECKOUT_FORM.ON_CLICK_BUTTON ||
                        fullWidth) &&
                      reservations.size === idx + 1
                    }
                    serviceHasImage={
                      reservation &&
                      reservation.get("inventory") &&
                      serviceHasImage[reservation.get("inventory").get("ticker")]
                    }
                    handleAddReservation={this.handleAddReservation}
                    handleShareBookingCart={this.handleShareBookingCart}
                    handleChangeNumberOfUnits={this.handleChangeNumberOfUnits}
                    maxBookableRooms={maxBookableRooms}
                    showBookingOptionSummary={showBookingOptionSummary}
                    showServices={showServices && !this.state.hideExtrasModal}
                    showDiscountsCalculation={showDiscountsCalculation}
                    cancelRelease={cancelRelease}
                    roomDenomination={roomDenomination}
                    handleCloseModal={handleCloseModal}
                    backgroundColor={customStyles.get("bookingFormButtonBackgroundColor")}
                    textColor={customStyles.get("bookingFormButtonOppositeColor")}
                    cancellationRestrictions={cancellationRestrictions}
                    cancellationPoliciesInfo={cancellationPoliciesInfo}
                    extrasQuestionnaire={extrasQuestionnaire}
                    sortedServices={sortedServices[idx]}
                    showExtrasModal={showExtrasModal[idx] && !this.state.hideExtrasModal}
                    latestReservation={idx + 1 === reservations.size}
                    reservationIndex={idx}
                    hideObligatoryExtras={hideObligatoryExtras}
                    parentIndex={idx}
                    showBestPriceGuaranteed={showBestPriceGuaranteed}
                    guestsList={guestsList[reservation.get("id")]}
                    extraFilters={extraFilters}
                    activeExtraFilter={this.state.selectedExtra}
                    isTabFiltersCollapsed={isTabFiltersCollapsed}
                    isSharedBooking={isSharedBooking}
                  />
                ))}
              <ReservationTotalAmount
                currency={currency}
                defaultCurrency={defaultCurrency}
                defaultTotalAmount={reservationTotalRateToShow}
                totalAmount={bookingTotalRate}
                pending={pendingAmount}
                deposit={depositAmount}
                pendingAmountText={pendingAmountTextConfiguration}
                taxesText={this.props.taxesText}
                originalTotalTax={originalTotalTax}
                originalTotalCityTax={originalTotalCityTax}
                showCityTaxAddedText={
                  cityTaxConfiguration &&
                  cityTaxConfiguration !==
                    constants.CITY_TAX_CONFIGURATION.EXCLUDE_FROM_ALL_STEPS &&
                  originalTotalCityTax > 0
                }
              />

              {fullWidth && !hideReservation && (
                <div
                  className={classnames(
                    "wbkv9-Checkout-controlsContainer",
                    styles.controlsContainer
                  )}>
                  <div
                    className={classnames(
                      styles.addBookbutton,
                      "wbkv9-Checkout-control",
                      styles.control
                    )}
                    onClick={this.handleAddReservation}>
                    <FormattedMessage {...msgs.addAnother} />
                  </div>
                  <div
                    className={classnames("wbkv9-Checkout-control", styles.control)}
                    onClick={this.handleShareBookingCart}>
                    <FormattedMessage {...msgs.shareBookingCart} />
                  </div>
                </div>
              )}
            </div>
            <div
              className={classnames(
                styles.rightContainer,
                fullWidth && {
                  [styles.sideContainer]: true,
                  [styles.fullWidth]: true,
                }
              )}>
              {fullWidth && (
                <CheckoutForm
                  availablePayments={availablePayments}
                  createPCIProxyError={createPCIProxyError}
                  paypalButton={paypalButton}
                  onSubmit={this.handleSubmit}
                  handleSubmit={this.handleSubmit}
                  countries={countries}
                  fields={definedFields}
                  fieldConfiguration={fieldConfiguration}
                  messages={
                    taxesText === constants.TAXES_TEXT.TAXES_AND_FEES_INCLUDED
                      ? new Map()
                      : messages
                  }
                  creditCardTypes={creditCardTypes}
                  paymentType={paymentType}
                  paymentTypesAvailable={paymentTypesAvailable}
                  pendingTotal={pendingTotal}
                  bookingTotalRate={bookingTotalRate}
                  depositTotal={depositTotal}
                  bookingOriginalRate={reservationTotalRateToShow}
                  depositOriginalRate={depositOriginalRate}
                  pendingOriginal={pendingOriginal}
                  loading={loading}
                  currency={currency}
                  onSelectPaymentType={this.handleSelectPaymentType}
                  propertyTicker={propertyTicker}
                  media={media}
                  handleGallery={handleGallery}
                  defaultCurrency={defaultCurrency}
                  handleModalContent={handleModalContent}
                  handleCloseModal={handleCloseModal}
                  propertyContact={propertyContact}
                  propertyName={propertyName}
                  filteredConditions={filteredConditions}
                  cancelableUntilList={cancelableUntilList}
                  handleConditions={handleConditions}
                  showTransferDefaultMessage={configuration.get("showTransferDefaultMessage")}
                  pendingAmountTextConfiguration={pendingAmountTextConfiguration}
                  handleAddReservation={this.handleAddReservation}
                  handleShareBookingCart={this.handleShareBookingCart}
                  fullWidth={fullWidth}
                  handleMap={this.localHandleMap}
                  showLanguage={showElementsConfig.showLanguageSelector}
                  showCurrency={showElementsConfig.showCurrencySelector}
                  locale={locale}
                  availableLocales={availableLocales}
                  availableCurrencies={availableCurrencies}
                  handleChangeLocale={handleChangeLocale}
                  handleChangeConfiguration={handleChangeConfiguration}
                  promoCode={promoCode}
                  toggleBookingFormSummary={toggleBookingFormSummary}
                  idReservation={idReservation}
                  handlePCIProxySubmit={this.handlePCIProxySubmit}
                  pciProxyError={this.props.pciProxyError}
                  communicationsDisclaimer={communicationsDisclaimer}
                  privacyPolicy={privacyPolicy}
                  cancelRelease={cancelRelease}
                  reservationStartDate={earliestCancellationDate}
                  reservations={reservations}
                  guestFormQuestionnaire={guestFormQuestionnaire}
                  updateCustomFormValues={this.updateCustomFormValues}
                  isFormValid={this.isFormValid}
                  isCustomFormValid={!Object.values(this.state.formsValid).includes(false)}
                  touchFormGenerator={this.state.touch}
                  touchOnSubmit={this.touchOnSubmit}
                  selectedPayment={selectedPayment}
                  createPnPV2PaymentOrder={this.props.createPnPV2PaymentOrder}
                  tokenizePnPV2Error={this.props.tokenizePnPV2Error}
                  paymentError={this.state.paymentError || this.props.pnpV2PaymentOrderError}
                  formAsyncValidationErrors={this.props.formAsyncValidationErrors}
                  pnpV2PaymentToken={this.props.pnpV2PaymentToken}
                  createPnPV2PaymentOrderSuccess={this.props.createPnPV2PaymentOrderSuccess}
                  createPnPV2PaymentOrderError={this.props.createPnPV2PaymentOrderError}
                  hideDefaultPrivacyPolicy={hideDefaultPrivacyPolicy}
                  taxesText={this.props.taxesText}
                  expiration={expiration}
                  affiliateIsEncoded={affiliateIsEncoded}
                  affiliate={affiliate}
                  cancellationRestrictions={cancellationRestrictions}
                  cancellationPoliciesInfo={cancellationPoliciesInfo}
                  originalTotalTax={originalTotalTax}
                  originalTotalCityTax={originalTotalCityTax}
                />
              )}
            </div>
          </div>
          {!fullWidth && !iframeMode && (
            <Footer copyright={"WITBOOKING © " + new Date().getFullYear() + " - V.8"} />
          )}
          {fullWidth && (
            <div
              className={classnames(
                "wbkv9-Checkout-Footer",
                "wbkv9-Footer2",
                styles.footer,
                reservations && reservations.size < 2 && styles.hasBorder
              )}>
              <Footer
                fullWidth={fullWidth}
                propertyName={propertyName}
                propertyContact={propertyContact}
                handleMap={this.localHandleMap}
                showLanguage={showElementsConfig.showLanguageSelector}
                showCurrency={showElementsConfig.showCurrencySelector}
                locale={locale}
                currency={currency}
                locales={availableLocales}
                currencies={availableCurrencies}
                onLanguageChange={handleChangeLocale}
                onCurrencyChange={handleChangeConfiguration}
                promoCode={promoCode}
                toggleBookingFormSummary={toggleBookingFormSummary}
                handleCloseModal={handleCloseModal}
                handleModalContent={handleModalContent}
              />
            </div>
          )}
        </div>

        {(ariLoading || this.state.loader) && (
          <StyledARILoaderContainer>
            <ARILoader />
          </StyledARILoaderContainer>
        )}
      </div>
    );
  }
}

export default connect(
  createStructuredSelector({
    earliestCancellationDate: earliestCancellationDateSelector,
    cart: selectors.cartSelector,
    pendingAmountTextConfiguration: selectors.pendingAmountTextConfigurationSelector,
    addObligatoryExtrasRateToRoomSelection:
      selectors.addObligatoryExtrasRateToRoomSelectionSelector,
    customerFormConfiguration: customerFormFieldsSelector,
    ccFormFields: ccFormFieldsSelector,
    propertyTicker: selectors.propertyTickerSelector,
    messages: selectors.messagesSelector,
    defaultCurrency: selectors.defaultCurrencySelector,
    currency: selectors.currencySelector,
    paymentType: paymentTypeSelector,
    paymentTypesAvailable: selectors.availablePaymentsSelector,
    countries: selectors.countriesSelector,
    creditCardTypes: selectors.creditCardTypesSelector,
    paymentFormConfiguration: paymentFormFieldsSelector,
    reservationResource: reservationResourceSelector,
    loading: loadingSelector,
    reservation: selectors.reservationSelector,
    cancelRelease: selectors.cancelReleaseSelector,
    media: selectors.mediaSelector,
    propertyContact: selectors.propertyContactSelector,
    propertyName: selectors.propertyNameSelector,
    locale: selectors.localeSelector,
    fullWidth: selectors.fullWidthSelector,
    logos: selectors.logosSelector,
    showElementsConfig: selectors.showElementsConfigSelector,
    configuration: selectors.configurationSelector,
    serviceHasImage: serviceHasImageSelector,
    trackingData: selectors.trackingDataSelector,
    paymentTypesConfiguration: selectors.paymentTypesConfigurationSelector,
    showCheckoutForm: showCheckoutFormSelector,
    maxBookableRooms: selectors.maxBookableRoomsSelector,
    showBookingOptionSummary: selectors.showBookingOptionSummarySelector,
    showDiscountsCalculation: selectors.showDiscountsCalculationSelector,
    propertyIsDemo: selectors.propertyIsDemoSelector,
    roomDenomination: selectors.roomDenominationSelector,
    servicesCollapsed: servicesCollapsedSelector,
    availableLocales: selectors.availableLocalesSelector,
    availableCurrencies: selectors.availableCurrenciesSelector,
    promoCode: selectors.promoCodeSelector,
    pciProxyResponse: pciProxyResponseSelector,
    pciProxyError: pciProxyErrorSelector,
    communicationsDisclaimer: communicationsDisclaimerSelector,
    privacyPolicy: privacyPolicySelector,
    customStyles: selectors.customStylesSelector,
    isAgent: selectors.isAgentSelector,
    affiliate: selectors.affiliateSelector,
    affiliateIsEncoded: selectors.encodedAffiliateSelector,
    showAgentLogin: selectors.showAgentLoginSelector,
    cancellationRestrictions: selectors.cancellationRestrictionsCheckoutSelector,
    cancellationPoliciesInfo: selectors.cancellationPoliciesInfoCheckoutSelector,
    windowWidth: selectors.widthSelector,
    extrasQuestionnaire: extrasQuestionnaireSelector,
    guestFormQuestionnaire: guestFormQuestionnaireSelector,
    reservationsDates: reservationsDatesSelector,
    sortedServices: sortedServicesSelector,
    showExtrasModal: showExtrasModalSelector,
    hideDefaultPrivacyPolicy: hideDefaultPrivacyPolicySelector,
    availablePayments: availablePaymentsSelector,
    selectedPayment: selectedPaymentSelector,
    pnpV2PaymentOrderSuccess: pnpV2PaymentOrderSuccessSelector,
    pnpV2PaymentOrderError: pnpV2PaymentOrderErrorSelector,
    formAsyncValidationErrors: formAsyncValidationErrorsSelector,
    pnpV2PaymentToken: pnpV2PaymentTokenSelector,
    hideObligatoryExtras: hideObligatoryExtrasSelector,
    showServices: showServicesSelector,
    showBestPriceGuaranteed: showBestPriceGuaranteedSelector,
    guestsList: selectors.guestsListSelector,
    taxesText: selectors.checkoutTaxesTextSelector,
    ariLoading: selectors.ariLoadingSelector,
    reservationTotalAmount: reservationTotalAmountSelector,
    tags: selectors.tagsSelector,
    extraFilters: selectors.extraFiltersSelector,
    propertyActiveTab: selectors.propertyActiveTabSelector,
    isTabFiltersCollapsed: selectors.isExtraTabFiltersCollapsedUISelector,
    isSharedBooking: isSharedBookingSelector,
    cityTaxConfiguration: appSelectors.cityTaxConfigurationSelector,
  }),
  dispatch =>
    bindActionCreators(
      {
        ...actions,
        ...appActions,
        ...reservationActions,
      },
      dispatch
    )
)(injectIntl(withRouter(withSessionData(Checkout))));

//TODO: Correct proptypes
// Checkout.propTypes = {
//   removeReservation: PropTypes.func,
//   propertyTicker: PropTypes.string,
//   reservation: PropTypes.object.isRequired
// };
